import React from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EventIcon from "@mui/icons-material/Event";
import PeopleIcon from "@mui/icons-material/People";
import NotificationsIcon from "@mui/icons-material/Notifications";
import VerifiedIcon from "@mui/icons-material/Verified";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

const drawerWidth = 220;

const navItems = [
  { label: "Dashboard", icon: <DashboardIcon />, path: "/" },
  { label: "Scenarios", icon: <AutoFixHighIcon />, path: "/scenarios" },
  { label: "Wallets", icon: <AccountBalanceWalletIcon />, path: "/wallets" },
  { label: "Trades", icon: <SwapHorizIcon />, path: "/trades" },
  { label: "P&L Dashboard", icon: <TrendingUpIcon />, path: "/pnl" },
  { label: "Events", icon: <EventIcon />, path: "/events" },
  { label: "User Management", icon: <PeopleIcon />, path: "/users" },
  {
    label: "Notifications",
    icon: <NotificationsIcon />,
    path: "/notifications",
  },
  {
    label: "Validation Demo",
    icon: <VerifiedIcon />,
    path: "/validation-demo",
  },
  {
    label: "Market Dashboard",
    icon: <ShowChartIcon />,
    path: "/market",
  },
];

export function Sidebar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItemButton key={item.label} sx={{ borderRadius: 1 }}>
            <NavLink
              to={item.path}
              className={({ isActive }) => (isActive ? "sidebar-active" : "")}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </NavLink>
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
}
